<!-- CONTAINER -->
<div class="container content-area relative">

    <!-- PAGE-HEADER -->
    <div class="page-header">
        <h4 class="page-title">Edit Guidance Card</h4>
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
            <li class="breadcrumb-item"><a [routerLink]="['/admin/guidance-category/list']">Guidance Card</a></li>
            <li class="breadcrumb-item active" aria-current="page">Edit</li>
        </ol>
    </div>
    <!-- PAGE-HEADER END -->

    <!-- ROW-1 OPEN -->
    <div class="row" id="user-profile">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div>
                        <form [formGroup]="formGroup" (submit)="submit()">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h3 class="card-title">Edit Guidance Detail</h3>
                                        </div>
                                        <div class="card-body">

                                            <div class="row">
                                                <div class="col-lg-6 col-md-6">
                                                    <div class="form-group">
                                                        <label for="categoryId">Guidance Category</label>
                                                        <ng-select placeholder="Guidance Category" appendTo="body"
                                                            [searchable]="true" [clearable]="true"
                                                            formControlName="guidanceCategoryId">
                                                            <ng-option selected disabled value=''>Guidance
                                                                Category</ng-option>
                                                            <ng-option *ngFor="let cat of categories" [value]="cat._id">
                                                                {{cat.name}}
                                                            </ng-option>
                                                        </ng-select>
                                                        <small *ngIf="f.guidanceCategoryId.invalid &&
                                        (f.guidanceCategoryId.dirty || f.guidanceCategoryId.touched)
                                        " class="d-block alert alert-danger mt-1">
                                                            Required.
                                                        </small>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-md-6">
                                                    <div class="form-group">
                                                        <label for="categoryId">Guidance Card</label>
                                                        <ng-select placeholder="Select Guidance Card" appendTo="body"
                                                            [searchable]="true" [clearable]="true"
                                                            formControlName="guidanceCardId">
                                                            <ng-option selected disabled value=''>Select Guidance
                                                                Card</ng-option>
                                                            <ng-option *ngFor="let card of cards" [value]="card._id">
                                                                {{card.name}}
                                                            </ng-option>
                                                        </ng-select>
                                                        <small *ngIf="f.guidanceCardId.invalid &&(f.guidanceCardId.dirty || f.guidanceCardId.touched)
                                    " class="d-block alert alert-danger mt-1">
                                                            Required.
                                                        </small>
                                                    </div>
                                                </div>

                                            </div>


                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>Detail...</label>
                                                    <editor formControlName="guidanceDetail"
                                                        apiKey="5htjgx7dn5e5l8gykrxdfb93yz76oufgwmeuv2x1fdyvqqiy"
                                                        [init]="tinymceConfig">
                                                    </editor>

                                                </div>
                                                <div class="col-md-6">
                                                    <label>Brief..</label>
                                                    <editor formControlName="guidanceBrief"
                                                        apiKey="5htjgx7dn5e5l8gykrxdfb93yz76oufgwmeuv2x1fdyvqqiy"
                                                        [init]="tinymceConfig">
                                                    </editor>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-success mt-1"
                                               >Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div><!-- COL-END -->
    </div>
    <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->
